import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import ScrollToTop from "./ScrollToTop";

function App({ keycloak }) {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <div className="main-content">
          <Routes>
            <Route exact path="/" element={<Home keycloak={keycloak} />}>
              {" "}
            </Route>
          </Routes>
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
